<template>
  <div id="requirelogin-form-wrapper" v-bind:style="{top: reservationData.top}">
    <div class="close" v-on:click="closeForm"></div>
    <v-form ref="form">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 class="info-block">
            {{$t('Login or Create an Account to make reservations')}}
          </v-flex>
          <v-flex xs6>
            <router-link to="/login" tag="button">
              <v-btn color="success" width="200">{{$t('Log In')}}</v-btn>
            </router-link>
          </v-flex>
          <v-flex xs6>
            <router-link to="/register" tag="button">
              <v-btn color="success">{{$t('Create an Account')}}</v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
    export default {
        props: ["reservationData"],
        methods: {
            closeForm: function () {
                this.reservationData.requireLoginFormVisible = false;
            },
        }
    }
</script>
<style lang="scss" scoped>
  #requirelogin-form-wrapper {
    background: #fff; max-width: 700px; width: 100%; margin: 0 auto; position: absolute; z-index: 2;
    left: 50%; transform: translateX(-50%); padding: 40px 30px 20px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);
    @media only screen and (max-width: 520px) {
      padding: 40px 0 20px;
      .v-text-field {padding-top: 0;}
    }
    .row {
      display: flex; padding: 5px 0;
    }
    .info-block {margin: 0 0 30px; font-size: 1.1rem;}
    .close {
      width: 30px; height: 30px; position: absolute; right: 10px; top: 10px; cursor: pointer;
      &::before {width: 3px; height: 30px; background: #000; content: ''; display: inline-block; transform: rotate(45deg); position: absolute; right: 13px;}
      &::after {width: 3px; height: 30px; background: #000; content: ''; display: inline-block; transform: rotate(-45deg); position: absolute; right: 13px;}
      &:hover {opacity: 0.8;}
    }
    button {
      width: 100%;
      button {
        width: 70%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/calendar/RequireLoginForm.vue